import { EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { Action, createReducer, on } from '@ngrx/store';

import { Article, ArticleClientMapping, Client } from '@interfaces';
import {
  addArticleClientMappingSuccess,
  getArticlesByClientIdSuccess,
  getClientByArticleNumberSuccess,
  getClientInfoWithFiltersSuccess,
  removeArticleClientMappingSuccess,
  setArticle,
  setArticlesByClientIdLoading,
  setClientInfoFiltersLoading,
} from './articles.actions';

export const ARTICLES_FEATURE_KEY = 'articles';

export interface ArticlesState {
  article: Article | null;
  clients: Client[] | null;
  clientsByArticleNumber: ArticleClientMapping[] | null;
  selectedClient: Client | null;
  articlesByClientId: Article[] | null;
  articlesByClientIdLoading: boolean;
  filteredClients: ArticleClientMapping[] | null;
  filteredClientsLoading: boolean;
}

export interface ArticlesPartialState {
  readonly [ARTICLES_FEATURE_KEY]: ArticlesState;
}

export const articlesAdapter: EntityAdapter<Article> =
  createEntityAdapter<Article>();

export const initialArticlesState: ArticlesState = {
  article: null,
  clients: null,
  selectedClient: null,
  articlesByClientId: null,
  articlesByClientIdLoading: false,
  clientsByArticleNumber: null,
  filteredClients: null,
  filteredClientsLoading: false,
};

const reducer = createReducer(
  initialArticlesState,
  on(setArticle, (state, { article }) => {
    return {
      ...state,
      article,
    };
  }),

  on(setArticlesByClientIdLoading, (state, { loading }) => {
    return {
      ...state,
      articlesByClientIdLoading: loading,
    };
  }),
  on(getArticlesByClientIdSuccess, (state, { articles }) => {
    return {
      ...state,
      articlesByClientId: articles,
    };
  }),

  on(getClientByArticleNumberSuccess, (state, { clients }) => {
    return {
      ...state,
      clientsByArticleNumber: clients,
    };
  }),

  on(
    removeArticleClientMappingSuccess,
    (state, { articleId, clientId, companyCode }) => {
      const updatedClientsByArticleNumber =
        state.clientsByArticleNumber?.filter(
          (mapping) =>
            !(
              mapping.articleId === articleId &&
              mapping.clientId === clientId &&
              mapping.companyCode === companyCode
            ),
        ) || null;

      return {
        ...state,
        clientsByArticleNumber: updatedClientsByArticleNumber,
      };
    },
  ),

  on(addArticleClientMappingSuccess, (state, { mapping }) => {
    const updatedClientsByArticleNumber = state.clientsByArticleNumber
      ? [...state.clientsByArticleNumber]
      : [];

    if (mapping) {
      updatedClientsByArticleNumber.push(mapping);
    }

    return {
      ...state,
      clientsByArticleNumber: updatedClientsByArticleNumber,
    };
  }),

  on(setClientInfoFiltersLoading, (state, { loading }) => {
    return {
      ...state,
      filteredClientsLoading: loading,
    };
  }),

  on(getClientInfoWithFiltersSuccess, (state, { clients }) => {
    return {
      ...state,
      filteredClients: clients,
    };
  }),
);

export function articlesReducer(
  state: ArticlesState | undefined,
  action: Action,
) {
  return reducer(state, action);
}
